document.addEventListener('DOMContentLoaded', function () {
    const DRAWER_CLOSE_EVENT = 'drawer-menu:close';
    const menuOpenBtn = document.querySelector('.js--hamburger-menu.-open');
    const menuCloseBtn = document.querySelector('.js--hamburger-menu.-close');
    const drawerMenu = document.querySelector('.js--drawer-menu');
    const bodyInner = document.querySelector('.js--body-inner');

    if (!menuOpenBtn || !menuCloseBtn || !drawerMenu || !bodyInner) return;

    /**
     * メニューを開く処理
     */
    function openMenu() {
        drawerMenu.classList.add('select');

        const scrollPos = window.scrollY || window.pageYOffset || 0;
        bodyInner.dataset.scroll = String(scrollPos);

        bodyInner.classList.add('scroll-prevent');
        bodyInner.style.top = `-${scrollPos}px`;

        drawerMenu.setAttribute('aria-hidden', 'false');
    }

    /**
     * メニューを閉じる処理
     */
    function closeMenu() {
        if (!drawerMenu.classList.contains('select')) return;

        drawerMenu.classList.remove('select');

        bodyInner.classList.remove('scroll-prevent');
        bodyInner.style.top = '0px';

        const savedScroll = Number(bodyInner.dataset.scroll || 0);
        window.scrollTo(0, savedScroll);

        drawerMenu.setAttribute('aria-hidden', 'true');
    }

    menuOpenBtn.addEventListener('click', openMenu);
    menuCloseBtn.addEventListener('click', closeMenu);
    document.addEventListener(DRAWER_CLOSE_EVENT, closeMenu);
});